import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import CustomVideoPlayer from '../../../src/components/custom-video-player';
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/13340707/aeb3216e-a22c-4a98-b268-31d9ab7990cc",
        "alt": "An image displaying a section intro with a title, description and a link."
      }}></img></p>
    <ul>
      <li parentName="ul">{`Label: An optional label to provide leading context to the section intro.`}</li>
      <li parentName="ul">{`Heading: The title of the section.`}</li>
      <li parentName="ul">{`Description: An optional description of the section.`}</li>
      <li parentName="ul">{`Link: An optional link to expand on the content introduced.`}</li>
    </ul>
    <h2>{`Usage`}</h2>
    <p>{`Use the section intro to introduce a new section element in the page. The section intro uses the full-width of the screen and can be used in conjunction with other components that expand the content introduced. For example, the `}<a parentName="p" {...{
        "href": "/components/Card"
      }}>{`card`}</a>{` or the `}<a parentName="p" {...{
        "href": "/components/Pillar"
      }}>{`pillar`}</a>{` components.`}</p>
    <p>{`We recommmend using the section intro as a header of an HTML `}<inlineCode parentName="p">{`<section>`}</inlineCode>{` element. Sections divide the content of the page into thematic groups and represent standalone elements that are typically related to a specific topic or subject within the document.`}</p>
    <p>{`Sections are designed to be self-contained, meaning they should make sense and be meaningful even when viewed independently from the rest of the page. They provide a way to divide the content into meaningful and structured blocks.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/eb8c5797-1704-4a92-8f9f-69c0b895f2b7" />
    <Caption mdxType="Caption">
      Use section intros to introduce a new topic in a section and combine it
      with other components and content.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/7890cbc2-e588-4399-b903-78f2e581d05b" />
    <Caption mdxType="Caption">
      Don't use it as standalone element followed by other section intros.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Options`}</h2>
    <h3>{`Align`}</h3>
    <p>{`Section intro can be aligned to the start or center of the page. By default, the section intro is aligned to the start of the page to allow for an image or a visual asset to be positioned on the left. Use the center alignment if the asset is centered, not present, or the scenario calls for it.`}</p>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/1d2b0be3-e696-4d4d-9b65-e8bced96fe04" />
    <Caption mdxType="Caption">
      Use center alignment if the section intro is paired with a centered image
      or visual asset.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/fa2f7c30-dd11-4b56-82ed-dbcb76245c6e" />
    <Caption mdxType="Caption">
      Don't use center alignment if the section intro is paired with an image or
      visual asset aligned to the left.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Hero"
        }}>{`Hero`}</a>{`: Use the hero component to render a full-width banner on a webpage.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/CTABanner"
        }}>{`CTABanner`}</a>{`: To draw attention to or create urgency around a user action.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      